<template>
  <div class="fold_module">
    <div :class="{'retract': status}" :style="{'max-height':status ? textHeight: ''}" ref="textContainer">
      <div class="fold_content">
        <div class="fold_content_item" v-for="item in slotDetail">
          <div class="slotDetail">
            {{ item.slotDetailName }}：
            {{ item.slotDetailDesc }}
          </div>
        </div>
      </div>
      <div class="fold_btn">
        <p v-if="status" @click="status = false" style="cursor:pointer">展开</p>
      </div>
    </div>
    <div class="fold_btn" style="margin-top: -8px" >
      <p v-if="status == false" @click="status = true" style="cursor:pointer">收起</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "fold_module",
  props: {
    slotDetail: Array
  },
  data() {
    return {
      textHeight: null,
      status: null
    }
  },
  mounted() {

    this.$nextTick(() => {
      this.calculateText()
    })
    window.onresize = () => {
      this.status = null;
      setTimeout(() => {
            this.calculateText()
          },
          0
      )
    }
  },
  methods: {
    calculateText() {
      let lineHeight = 18
      let twoHeight = lineHeight * 1 || 40
      this.textHeight = `${twoHeight + 8 }px`
      let txtDom = this.$refs.textContainer
      if(!txtDom) return;
      let curHeight = txtDom.offsetHeight
      if (curHeight > twoHeight + 8) { // 加slotDetail的padding-bottom
        this.status = true;
      } else {
        this.status = null;
      }

    }
  }
}
</script>

<style lang="less">
.fold_module {
  display: flex;
  flex-direction: column;

  .retract {
    position: relative;
    overflow: hidden;

    display: flex;
    flex-direction: row;

    .fold_content{
      width: 515px;
      margin-right: 18px;
      .slotDetail {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }


  .fold_content_item {
    display: flex;
    flex-direction: row;
    font-size: 12px;
    color: #666666;
    letter-spacing: 0;
    line-height: 18px;
    font-weight: 400;

    .slotDetail {
      padding-bottom: 8px;
    }

  }

  .fold_btn {
    font-size: 12px;
    color: var(--theme-color);
    letter-spacing: 0;
    text-align: right;
    line-height: 18px;
    font-weight: 400;
    flex-shrink: 0;
    flex-grow: 0;
  }
}
</style>

